export default __webpack_public_path__ + "static/media/logo.959f2a5d.svg";